// OTURUM NABZI — tek oturum kuralının "eski ekrana anlık bildirim" ayağı (global kural 05.10.2026).
//
// Aynı kullanıcı başka yerden girince sunucu bu oturumun isteklerine 401 SESSION_REPLACED döner ve client.ts
// oturumu kapatıp giriş ekranında sebebi gösterir. Kullanıcı ekranda hiçbir şey yapmıyorsa bunu ancak ilk
// tıklamasında öğrenirdi; nabız, sekmeye dönüldüğü an ve ekran açıkken 30 sn'de bir küçük bir soru sorar.
// Neden canlı bağlantı (SignalR) değil: arayüz bugün hiç canlı bağlantı kullanmıyor; her ekrana kalıcı bağlantı
// eklemek yeni bağımlılık + sürekli yük demek. Sekme gizliyken istek ATILMAZ; sunucu cevabı bellekten verir.
import type { AxiosInstance } from 'axios';

const ARALIK_MS = 30_000;
let zamanlayici: ReturnType<typeof setInterval> | null = null;
let kurulu = false;

export function oturumNabziniBaslat(istemci: AxiosInstance, oturumVarMi: () => boolean): void {
  if (kurulu || typeof document === 'undefined') return;
  kurulu = true;

  const sor = () => {
    if (document.visibilityState !== 'visible' || !oturumVarMi()) return;
    // 401 SESSION_REPLACED'i client.ts yakalayıcısı işler; burada başka hata ekrana yansıtılmaz.
    istemci.get('/api/auth/oturum').catch(() => undefined);
  };

  const ayarla = () => {
    if (zamanlayici) clearInterval(zamanlayici);
    zamanlayici = document.visibilityState === 'visible' ? setInterval(sor, ARALIK_MS) : null;
  };

  document.addEventListener('visibilitychange', () => {
    ayarla();
    sor();
  });
  window.addEventListener('focus', sor);
  ayarla();
}
